import { LoadingWrapper } from "styles/styledComponents/loadingWrapper";

const Loading = () => {
  return (
    <LoadingWrapper>
      <div className="loader"></div>
    </LoadingWrapper>
  );
};

export default Loading;
